import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b5f518c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzOffline: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/offline/index.vue').default,RzNotificationCenter: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/notification-center/index.vue').default})
